import DebugMenu from './DebugMenu';

export default DebugMenu;
